/* Koji Cards – botao "Ver em 3D" e troca de cor do modelo 3D.
   1) Celular/tablet com AR: o Shopify cuida do clique (abre o AR).
      Computador (mouse) ou aparelho sem AR: o clique leva ao slide do modelo 3D.
      O teste de mouse cobre o Safari do Mac, que se declara compativel com AR mas nao abre nada.
   2) Produto com um modelo 3D por cor (a cor vem do texto alternativo do modelo, ex.:
      "... Azul - modelo 3D da caixa"): a galeria mostra um so slide 3D com botoes de cor;
      a cor escolhida vale para a visualizacao, para o AR e acompanha a variante escolhida.
   3) No celular com AR, tocar em "Ver em 3D" abre um menu de cores; a escolha abre o AR
      direto naquela cor (a tela de AR e do sistema e nao aceita botoes do site). */
(function () {
  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  var colorPickers = [];
  var SWATCH_FALLBACK = {
    azul: '#1f4fa3', vermelho: '#c0392b', preto: '#1b1b1b', branco: '#f4f4f4',
    verde: '#2e7d4f', dourado: '#c9a227', prata: '#b8bcc2', roxo: '#6a3fa0', rosa: '#e58fb0'
  };

  function useFallback(button) {
    return desktop.matches || button.hasAttribute('data-shopify-xr-hidden');
  }

  function markButtons() {
    var buttons = document.querySelectorAll('.product__media__wrapper > .btn--ar');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('koji-ar--fallback', useFallback(buttons[i]));
    }
  }

  function selectModel(button) {
    var wrapper = button.closest('.product__media__wrapper');
    if (!wrapper) return;
    var slide = wrapper.querySelector('[data-media-slide][data-type="model"]');
    if (!slide) return;
    var id = slide.getAttribute('data-media-id');

    var thumb = wrapper.querySelector('[data-media-select="' + id + '"]');
    if (thumb) {
      thumb.click();
    } else {
      var slideshow = wrapper.querySelector('[data-product-slideshow]');
      var flkty = window.Flickity && window.Flickity.data ? window.Flickity.data(slideshow) : null;
      if (flkty) flkty.selectCell('[data-media-id="' + id + '"]');
    }

    var poster = slide.querySelector('.shopify-model-viewer-ui__button--poster');
    if (poster) setTimeout(function () { poster.click(); }, 400);
  }

  function pickerFor(button) {
    for (var i = 0; i < colorPickers.length; i++) {
      if (colorPickers[i].xrButton === button) return colorPickers[i];
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.product__media__wrapper > .btn--ar');
    if (!button) {
      // toque fora do menu de cores fecha o menu
      if (!event.target.closest('.koji-ar-chooser')) closeChoosers();
      return;
    }
    if (useFallback(button)) {
      event.preventDefault();
      event.stopPropagation();
      selectModel(button);
      return;
    }
    // celular com AR: com mais de uma cor, primeiro escolhe a cor
    var picker = pickerFor(button);
    if (picker && !button.kojiBypass) {
      event.preventDefault();
      event.stopPropagation();
      toggleChooser(picker);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeChoosers();
  });

  function closeChoosers() {
    for (var i = 0; i < colorPickers.length; i++) {
      var c = colorPickers[i].chooser;
      if (c && !c.hidden) {
        c.hidden = true;
        colorPickers[i].xrButton.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function toggleChooser(picker) {
    var chooser = picker.chooser;
    if (!chooser.hidden) { closeChoosers(); return; }
    closeChoosers();
    chooser.hidden = false;
    var button = picker.xrButton;
    chooser.style.top = (button.offsetTop - chooser.offsetHeight - 8) + 'px';
    chooser.style.left = Math.max(8, button.offsetLeft + button.offsetWidth - chooser.offsetWidth) + 'px';
    button.setAttribute('aria-expanded', 'true');
  }

  function buildChooser(picker) {
    var chooser = document.createElement('div');
    chooser.className = 'koji-ar-chooser';
    chooser.hidden = true;
    chooser.setAttribute('role', 'group');
    chooser.setAttribute('aria-label', 'Escolha a cor para ver na sua mesa');

    picker.order.forEach(function (value) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'koji-ar-chooser__btn';
      b.setAttribute('data-color', value);
      b.style.setProperty('--koji-3d-color', picker.colorOf(value));
      b.textContent = value;
      b.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        picker.setColor(value);
        closeChoosers();
        // abre o AR do Shopify ja com o modelo da cor escolhida (mesmo toque do cliente)
        var xr = picker.xrButton;
        xr.kojiBypass = true;
        xr.click();
        xr.kojiBypass = false;
      });
      chooser.appendChild(b);
    });

    picker.wrapper.appendChild(chooser);
    picker.xrButton.setAttribute('aria-haspopup', 'true');
    picker.xrButton.setAttribute('aria-expanded', 'false');
    return chooser;
  }

  /* ---------- troca de cor do modelo 3D ---------- */

  function absoluteUrl(url) {
    return url && url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  // cor da amostra do tema (so vale depois que o tema carrega as amostras; #ccc e o valor provisorio)
  function themeSwatch(optionName, value) {
    var input = document.querySelector('input[name="options[' + optionName + ']"][value="' + value + '"]');
    var label = input && input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var swatch = label ? getComputedStyle(label).getPropertyValue('--swatch').trim() : '';
    return swatch && swatch.toLowerCase() !== '#ccc' ? swatch : '';
  }

  function swatchColor(optionName, value) {
    return themeSwatch(optionName, value) || SWATCH_FALLBACK[value.toLowerCase()] || '#c7c9cf';
  }

  function initColorModels(json) {
    var models;
    try { models = JSON.parse(json.textContent); } catch (e) { return; }
    if (!models || models.length < 2) return;

    var section = json.parentElement;
    while (section && !section.querySelector('.product__media__wrapper')) section = section.parentElement;
    if (!section) return;
    var wrapper = section.querySelector('.product__media__wrapper');
    var productJson = section.querySelector('script[data-product-json]');
    var product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

    var optionIndex = -1;
    (product.options || []).forEach(function (name, i) {
      if (optionIndex === -1 && /^(cor|cores|color|colour)$/i.test(String(name).trim())) optionIndex = i;
    });
    if (optionIndex === -1) return;
    var optionName = product.options[optionIndex];

    var values = [];
    product.variants.forEach(function (v) {
      var value = v.options[optionIndex];
      if (values.indexOf(value) === -1) values.push(value);
    });

    var byColor = {};
    var order = [];
    models.forEach(function (m) {
      var alt = String(m.alt || '').toLowerCase();
      values.forEach(function (value) {
        if (!byColor[value] && alt.indexOf(value.toLowerCase()) !== -1) {
          var glb = (m.sources || []).filter(function (s) { return s.format === 'glb'; })[0];
          byColor[value] = { id: String(m.id), glb: glb && absoluteUrl(glb.url), poster: m.preview_image && absoluteUrl(m.preview_image.src) };
          order.push(value);
        }
      });
    });
    if (order.length < 2) return;

    // um so slide 3D na galeria: fica o primeiro, os outros saem (antes do tema montar o carrossel)
    var primarySlide = null;
    order.forEach(function (value) {
      var slide = wrapper.querySelector('[data-media-slide][data-media-id="' + byColor[value].id + '"]');
      if (!slide) return;
      if (!primarySlide) {
        primarySlide = slide;
      } else {
        slide.parentNode.removeChild(slide);
        var thumb = wrapper.querySelector('[data-media-select="' + byColor[value].id + '"]');
        if (thumb) thumb.parentNode.removeChild(thumb);
      }
    });
    if (!primarySlide) return;

    var viewer = primarySlide.querySelector('model-viewer');
    var xrButton = wrapper.querySelector('[data-shopify-xr]');
    var activeColor = null;

    var bar = document.createElement('div');
    bar.className = 'koji-3d-colors';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Cor do modelo 3D');
    order.forEach(function (value) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'koji-3d-colors__btn';
      b.setAttribute('data-color', value);
      b.setAttribute('aria-label', value);
      b.setAttribute('title', value);
      b.style.setProperty('--koji-3d-color', swatchColor(optionName, value));
      b.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setColor(value);
      });
      bar.appendChild(b);
    });
    (primarySlide.querySelector('.media__contain') || primarySlide).appendChild(bar);

    function setColor(value) {
      var model = byColor[value];
      if (!model || value === activeColor) return;
      activeColor = value;
      if (viewer && model.glb) {
        viewer.setAttribute('src', model.glb);
        if (model.poster) viewer.setAttribute('poster', model.poster);
      }
      if (xrButton) xrButton.setAttribute('data-shopify-model3d-id', model.id);
      var buttons = bar.querySelectorAll('.koji-3d-colors__btn');
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i].getAttribute('data-color') === value;
        buttons[i].classList.toggle('is-active', on);
        buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    // o tema reescreve o modelo do botao de AR ao tocar no 3D: mantem a cor escolhida
    if (xrButton && window.MutationObserver) {
      new MutationObserver(function () {
        var model = byColor[activeColor];
        if (model && xrButton.getAttribute('data-shopify-model3d-id') !== model.id) {
          xrButton.setAttribute('data-shopify-model3d-id', model.id);
        }
      }).observe(xrButton, { attributes: true, attributeFilter: ['data-shopify-model3d-id'] });
    }

    // acompanha a cor escolhida no seletor de variante (o evento sai do formulario do produto,
    // na mesma secao da galeria)
    var scope = wrapper.closest('.shopify-section') || section;
    document.addEventListener('theme:variant:change', function (event) {
      if (!event.target || !scope.contains(event.target)) return;
      var variant = event.detail && event.detail.variant;
      if (variant && variant.options) setColor(variant.options[optionIndex]);
    });

    // quando o tema terminar de carregar as amostras, usa a cor exata delas nos botoes
    window.addEventListener('load', function () {
      setTimeout(function () {
        var buttons = bar.querySelectorAll('.koji-3d-colors__btn');
        for (var i = 0; i < buttons.length; i++) {
          var exact = themeSwatch(optionName, buttons[i].getAttribute('data-color'));
          if (exact) {
            buttons[i].style.setProperty('--koji-3d-color', exact);
            var item = wrapper.querySelector('.koji-ar-chooser__btn[data-color="' + buttons[i].getAttribute('data-color') + '"]');
            if (item) item.style.setProperty('--koji-3d-color', exact);
          }
        }
      }, 300);
    });

    var checked = section.querySelector('input[name="options[' + optionName + ']"]:checked');
    setColor(checked && byColor[checked.value] ? checked.value : order[0]);

    if (xrButton) {
      var picker = {
        wrapper: wrapper,
        xrButton: xrButton,
        order: order,
        setColor: setColor,
        getActive: function () { return activeColor; },
        colorOf: function (value) {
          var dot = bar.querySelector('.koji-3d-colors__btn[data-color="' + value + '"]');
          return dot ? dot.style.getPropertyValue('--koji-3d-color') : swatchColor(optionName, value);
        }
      };
      picker.chooser = buildChooser(picker);
      colorPickers.push(picker);
    }
  }

  function init() {
    var jsons = document.querySelectorAll('script[id^="ModelJson-"]');
    for (var i = 0; i < jsons.length; i++) initColorModels(jsons[i]);
    markButtons();
  }

  // roda antes do theme.js (ambos com defer, este vem antes no layout)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', markButtons);
  if (desktop.addEventListener) desktop.addEventListener('change', markButtons);
})();
